import { render } from "./Flex.vue?vue&type=template&id=0e3c2993&scoped=true"
import script from "./Flex.vue?vue&type=script&lang=js"
export * from "./Flex.vue?vue&type=script&lang=js"

import "./Flex.vue?vue&type=style&index=0&id=0e3c2993&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e3c2993"]])

export default __exports__